/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILinksData } from '../organization-users-tile.props.autogenerated';

export interface IAccountOrganizationUsersTileLinks {
    links: ILinksData[];
    requestContext: Msdyn365.IRequestContext;

    /**
     * The telemetry content
     */
    telemetryContent?: ITelemetryContent;
    onTextChange?(index: number): (event: Msdyn365.ContentEditableEvent) => void;
}

export const AccountOrganizationUsersTileLinks: React.FC<IAccountOrganizationUsersTileLinks> = ({
    links,
    telemetryContent,
    onTextChange,
    requestContext
}) => {
    if (links.length === 0) {
        return null;
    }
    const editableLinks = _mapEditableLinks(links, telemetryContent);
    return (
        <div className='ms-account-organization-users-tile__links'>
            {editableLinks && editableLinks.length > 0 ? (
                <Msdyn365.Links links={editableLinks} editProps={{ onTextChange, requestContext }} />
            ) : null}
        </div>
    );
};

const _mapEditableLinks = (linkdata: ILinksData[], telemetryContent?: ITelemetryContent): Msdyn365.ILinksData[] | null => {
    if (!linkdata || linkdata.length === 0) {
        return null;
    }
    const editableLinks: Msdyn365.ILinksData[] = [];
    const payLoad = getPayloadObject('click', telemetryContent!, '');
    linkdata.forEach((link, index) => {
        payLoad.contentAction.etext = link.linkText;
        const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
        const editableLink: Msdyn365.ILinksData = {
            ariaLabel: link.ariaLabel,
            className: 'ms-account-organization-users-tile__link',
            linkText: link.linkText,
            linkUrl: link.linkUrl.destinationUrl,
            openInNewTab: link.openInNewTab,
            role: 'link',
            additionalProperties: attributes
        };
        editableLinks.push(editableLink);
    });

    return editableLinks;
};
